import { AdSetSettings } from './ad-set-settings';
import { AdSlot } from './ad-slot';

export class AdSet {
  private readonly id?: string;
  private settings?: AdSetSettings;
  private readonly adSlots: Set<AdSlot> = new Set();

  public getId (): string {
    if (typeof this.id === 'undefined') {
      throw new Error(`Attempt to access "id" of ${this.constructor.name} before initialization`);
    }

    return this.id;
  }

  public getAdSlots (): AdSlot[] {
    return [ ...this.adSlots.values() ];
  }

  public addAdSlot (adSlot: AdSlot): this {
    if (!this.hasAdSlot(adSlot)) {
      this.adSlots.add(adSlot);

      adSlot.setAdSet(this);
    }

    return this;
  }

  public hasAdSlot (adSlot: AdSlot): boolean {
    return this.adSlots.has(adSlot);
  }

  public removeAdSlot (adSlot: AdSlot): this {
    if (!this.hasAdSlot(adSlot)) {
      return this;
    }

    if (this.adSlots.delete(adSlot) && adSlot.getAdSet() === this) {
      adSlot.setAdSet(undefined);
    }

    return this;
  }

  public getSettings (): AdSetSettings {
    if (typeof this.settings === 'undefined') {
      throw new Error(`Attempt to access "settings" of ${this.constructor.name} before initialization`);
    }

    return this.settings;
  }

  public setSettings (settings: AdSetSettings): this {
    this.settings = settings;
    settings.setAdSet(this);
    return this;
  }
}
